import { QueryClient } from '@tanstack/react-query'
import { onSessionEnd } from './session.js'

export const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 10_000, retry: 1 } } })

// Cached profiles, threads, the Wall: none of it belongs to the next account (client review #7).
onSessionEnd(() => {
  void queryClient.cancelQueries()
  queryClient.clear()
})
